import React from "react";
import projectColorData from "../../js/projectData";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Animatespin, HeadingCom, SildeEventsCom } from "../../components";
import Functions from "./index.function";

const Projects = () => {
  const { isLoading, projectData, handleEvents, sliderSettings, baseURL } =
    Functions();
    
  return (
    <div className="xs:py-5 sm:py-6 lg:pt-5 lg:pb-16">
      <div className="xs:px-3 sm:px-6 lg:px-5 xl:px-10">
        <HeadingCom title={"Projects"} to={"/project"} />
      </div>
      <div className="lg:pt-14 xs:pt-5 sm:pt-6">
        {isLoading ? (
          <Animatespin />
        ) : (
          <div className="slider-container">
            <Slider {...sliderSettings}>
              {projectData?.projects?.map((value, index) => {
                return (
                  <div 
                    key={index} 
                    style={{ width: '380px' }}
                  >
                    <div style={{ padding: '0 20px' }}>
                      <SildeEventsCom
                        isSlider={true} // Add this prop
                        onClick={() => handleEvents(value?.id)}
                        eventthubmail={`${baseURL}/uploads/projects/thumbnail/${value?.hero_image}`}
                        eventsimgClassName={"h-[65%]"}
                        eventsTextClassName={"h-[35%]"}
                        maxWClassname={"w-full"}
                        textclassName={"lg:text-base"}
                        eventtheme={
                          projectColorData[index % projectColorData.length].eventtheme
                        }
                        eventTitle={value?.heading}
                        eventDis={value?.sub_heading}
                      />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;